module.exports = __webpack_public_path__ + "static/magic_hand_2-9c29fbcca546ae3d3feea03bbe661a02.jpg";